import { MixtureDetailDto, MixtureEditDto } from './mixture';

export const mapMixtureDetailToEdit = (
  dto: MixtureDetailDto
): MixtureEditDto => ({
  id: dto.id,
  no: dto.no,
  mixDate: dto.mixDate,
  description: dto.description,
  totalNumber: dto.totalNumber,
  totalAmount: dto.totalAmount,
  mixtureStatusId: dto.mixtureStatusId,
  parameterSetId: dto.parameterSetId,
  specificationId: dto.specificationId,
  userId: dto.userId,
  mixtureProducts: dto.mixtureProducts
});
